angular.module('jv.tracking.jobBoards.paramsFAC', [])

    .factory('jobBoardDataValidationFAC', [function () {
        return function(jobBoard){
            if(!(jobBoard.name && jobBoard.displayName && jobBoard.description && jobBoard.customFormat && jobBoard.standardFormat !== '-1')){
                return false;
            }
            if(jobBoard.name.indexOf(' ') >= 0){
                return false;
            }
            if(jobBoard.versions){
                if(jobBoard.versions.length === 0){
                    return false;
                } else{
                    for(var index in jobBoard.versions){
                        var jbVersion = jobBoard.versions[index];
                        if(!(jbVersion.fileName && jbVersion.sourceParameters)){
                            return false;
                        }

                        if(jbVersion.connector && jbVersion.connector.params){
                            if(!(jbVersion.connector.params.sftpDirectory
                                && jbVersion.connector.params.sftpHost
                                && jbVersion.connector.params.sftpUsername
                                && jbVersion.connector.params.sftpPassword
                                && jbVersion.connector.params.sftpPort
                            )){
                                return false;
                            }
                        }else{
                            return false;
                        }
                    }
                }
            }else{
                return false;
            }
            return true;
        };
    }])

    .factory('jobBoardDataSerializeFAC', [function () {
        return function(jobBoard){
            //Serialize source parameters as string
            if(jobBoard){
                jobBoard.paid = jobBoard.paid === true ? 'true' : 'false';
                jobBoard.standardFormat = jobBoard.customFormat === 'false' ? true : false;
                if(jobBoard.versions){
                    angular.forEach(jobBoard.versions, function(version){
                        if(version.sourceParameters){
                            version.sourceParameters = $.param(version.sourceParameters);
                        }
                    });
                }
            }
            return jobBoard;
        };
    }])

    .factory('jobBoardDataDeserializeFAC', [function () {
        return function(jobBoard){
            if(jobBoard){
                jobBoard.paid = jobBoard.paid === 'true';
                jobBoard.standardFormat = jobBoard.customFormat === 'false';

                if(jobBoard.versions){
                    //De-serialize parameter to actual object before POST to Back-End
                    angular.forEach(jobBoard.versions, function(version){
                        if(version.add){
                            delete version.add;
                        }
                        //de-parameterized source parameters
                        var sourceParameters = {};
                        if(angular.isString(version.sourceParameters)){
                            if(version.sourceParameters.indexOf('&') >= 0){
                                var queryParams = version.sourceParameters.split('&');
                                if(queryParams.length){
                                    for(var k=0; k<queryParams.length; k++){
                                        if(queryParams[k].indexOf('=') > 0){
                                            var paramKeyValue = queryParams[k].split('=');
                                            if(paramKeyValue.length === 2){
                                                sourceParameters[paramKeyValue[0]] = paramKeyValue[1];
                                            }
                                        }
                                    }
                                }
                            }else{
                                var keyValue = version.sourceParameters.split('=');
                                if(keyValue.length === 2){
                                    sourceParameters[keyValue[0]] = keyValue[1];
                                }
                            }
                        }
                        version.sourceParameters = sourceParameters;

                        if(version.notification && version.notification.toEmails && angular.isString(version.notification.toEmails)){
                            version.notification.toEmails = version.notification.toEmails.split(',');
                        }

                        if(version.connector){
                            version.connector['type'] = version.connector['type'] || 'SFTP';
                        }
                    });
                }
            }
            return jobBoard;
        };
    }]);
